import { useOrchestratorState } from './useOrchestratorState';
import { isComponentMap } from '../core/utils';
export function useHasComponent(componentKey) {
  const {
    currentStep
  } = useOrchestratorState();
  if (!currentStep) {
    return false;
  }
  const {
    component
  } = currentStep;
  if (isComponentMap(component)) {
    return componentKey in component && component[componentKey] !== undefined;
  }
  return false;
}
//# sourceMappingURL=useHasComponent.js.map